<template>
    <div class="fw-emp">
        <van-nav-bar :title="title" style="background-color: #CCD5E6;" left-text="" @click-left="onClickLeft" left-arrow
                     :fixed="true">
        </van-nav-bar>
        <div>
            <div style="margin-top: 10px">
                <div class="kuang-item">
                    <span>员工姓名</span>
                    <el-input v-model="form.empName" size="mini" placeholder="请输入姓名" class="ki"></el-input>
                </div>
                <div class="kuang-item">
                    <span>员工昵称</span>
                    <el-input v-model="form.nickName" size="mini" placeholder="请输入昵称" class="ki"></el-input>
                </div>
                <div class="kuang-item">
                    <span>员工手机</span>
                    <el-input v-model="form.empPhone" size="mini" placeholder="请输入号码" class="ki"></el-input>
                </div>
                <div class="kuang-item">
                    <span>员工性别</span>
                    <div class="mb-sex">
                        <el-radio-group v-model="form.empSex" style="margin-top: 7px;">
                            <el-radio :label="1">男</el-radio>
                            <el-radio :label="0" style="margin-left: 5px">女</el-radio>
                        </el-radio-group>
                    </div>
                </div>
                <!--                <div class="kuang-item">-->
                <!--                    <span>员工班次</span>-->
                <!--                    <div class="mb-sex">-->
                <!--                        <el-radio-group v-model="form.sex" style="margin-top: 7px;">-->
                <!--                            <el-radio :label="1">早班</el-radio>-->
                <!--                            <el-radio :label="2" style="margin-left: -10px">中班</el-radio>-->
                <!--                            <el-radio :label="2" style="margin-left: -10px">晚班</el-radio>-->
                <!--                        </el-radio-group>-->
                <!--                    </div>-->
                <!--                </div>-->
                <!--                <div class="kuang-item">-->
                <!--                    <span>可否预约</span>-->
                <!--                    <div class="mb-sex">-->
                <!--                        <el-radio-group v-model="form.sex" style="margin-top: 7px;">-->
                <!--                            <el-radio :label="1">可以</el-radio>-->
                <!--                            <el-radio :label="2" style="margin-left: -10px">不可以</el-radio>-->
                <!--                        </el-radio-group>-->
                <!--                    </div>-->
                <!--                </div>-->
                <!--                <div class="kuang-item">-->
                <!--                    <span>员工状态</span>-->
                <!--                    <div class="mb-sex">-->
                <!--                        <el-radio-group v-model="form.sex" style="margin-top: 7px;">-->
                <!--                            <el-radio :label="1">在职</el-radio>-->
                <!--                            <el-radio :label="2" style="margin-left: -10px">离职</el-radio>-->
                <!--                        </el-radio-group>-->
                <!--                    </div>-->
                <!--                </div>-->
            </div>
            <div>
                <span class="gangwei">岗位</span>
                <el-row>
                    <el-col :span="12">
                        <div class="gangweijibie">
                            <span class="g">岗位1</span>
                            <el-select v-model="form.firstStation" placeholder="请选择岗位1"
                                       @change="setJb(1)"
                                       size="mini"
                                       clearable>
                                <el-option
                                        v-for="item in gws1"
                                        :key="item.id"
                                        :label="item.paAttribute"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="gangweijibie">
                            <span class="j">级别</span>
                            <el-select v-model="form.firstLevel" placeholder="请选择级别1" clearable size="mini">
                                <el-option
                                        v-for="item in jbs1"
                                        :key="item.id"
                                        :label="item.gradeName"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <div class="gangweijibie">
                            <span class="g">岗位2</span>
                            <el-select v-model="form.secondStation" placeholder="请选择岗位2"
                                       size="mini"
                                       @change="setJb(2)" clearable>
                                <el-option
                                        v-for="item in gws2"
                                        :key="item.id"
                                        :label="item.paAttribute"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="gangweijibie">
                            <span class="j">级别</span>
                            <el-select v-model="form.secondLevel" placeholder="请选择级别2" clearable size="mini">
                                <el-option
                                        v-for="item in jbs2"
                                        :key="item.id"
                                        :label="item.gradeName"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <div class="gangweijibie">
                            <span class="g">岗位3</span>
                            <el-select v-model="form.thirdStation" placeholder="请选择岗位3"
                                       size="mini"
                                       @change="setJb(3)"
                                       clearable>
                                <el-option
                                        v-for="item in gws3"
                                        :key="item.id"
                                        :label="item.paAttribute"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="gangweijibie">
                            <span class="j">级别</span>
                            <el-select v-model="form.thirdLevel" placeholder="请选择级别3" clearable size="mini">
                                <el-option
                                        v-for="item in jbs3"
                                        :key="item.id"
                                        :label="item.gradeName"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div class="mb-btn">
                <van-button type="default" class="quedingbtn" @click="saveEmp">确定</van-button>
            </div>
        </div>
    </div>
</template>

<script>
    import {getCookie,} from "../../utils/auth";

    export default {
        components: {},
        data() {
            return {
                title: '新增店员',
                fwUser: {},
                deptId: '',
                token: '',
                form: {
                    deptId: '',
                    empName: '',
                    nickName: '',
                    empPhone: '',
                    empSex: 1,
                    firstStation: '',
                    secondStation: '',
                    thirdStation: '',
                    firstLevel: '',
                    secondLevel: '',
                    thirdLevel: '',
                },
                gws1: [],
                gws2: [],
                gws3: [],
                jbs1: [],
                jbs2: [],
                jbs3: [],
            };
        },
        async created() {
            document.title = "数字智慧助手"
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            console.log(this.deptId)
            this.token = this.fwUser.token
            this.getPlabsList()
        },
        methods: {
            async getPlabsList() {
                let res = await this.$get("/fw/getFwPlabsList", {deptId: this.deptId})
                this.gws1 = res.gws1
                this.gws2 = res.gws2
                this.gws3 = res.gws3
            },

            async saveEmp() {
                this.form.deptId = this.deptId
                let res = await this.$get("/fw/saveFwEmp", this.form)
                if (res.code == 200) {
                    this.$notify({type: 'success', message: res.message});
                    this.onClickLeft()
                } else {
                    this.$notify({type: 'danger', message: res.message});
                }
            },

            setJb(type) {
                if (type == 1) {
                    this.form.firstLevel = ''
                    if (this.gws1.length > 0) {
                        this.jbs1 = this.gws1[0].gradeList
                    }
                }
                if (type == 2) {
                    this.form.secondLevel = ''
                    if (this.gws2.length > 0) {
                        this.jbs2 = this.gws2[0].gradeList
                    }
                }
                if (type == 3) {
                    this.form.thirdLevel = ''
                    if (this.gws3.length > 0) {
                        this.jbs3 = this.gws3[0].gradeList
                    }
                }
            },

            onClickLeft() {
                this.$router.go(-1)
            },
        },
    };
</script>

<style lang="scss" scoped>
    .fw-emp {
        margin: 0 auto;
        height: 100%;
        position: relative;
        overflow: scroll;
        padding-top: 49px;
    }

    .kuang-item {
        width: 90%;
        margin: auto;
        display: flex;
        flex-direction: row;
        font-size: 13px;
        height: 40px;
        line-height: 45px;
    }

    .kuang-item span {
        width: 68px;
        text-align: right;
        font-weight: bold;
        padding-right: 10px;
    }

    .ki {
        width: 60%;
    }

    .mb-sex {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 40px;
    }

    .mb-btn {
        width: 100%;
        position: fixed;
        bottom: 0px;
    }

    .quedingbtn {
        width: 100%;
        text-align: center;
        height: 40px;
        background-color: red;
        color: #ffffff;
    }

    .gangwei {
        display: block;
        font-size: 13px;
        font-weight: bold;
        height: 28px;
        line-height: 28px;
        border-bottom: #EEEEEE solid 1px;
        margin: 16px 10px 5px 10px;
    }

    .gangweijibie {
        width: 90%;
        margin: auto;
        display: flex;
        flex-direction: row;
        font-size: 13px;
        height: 40px;
        line-height: 45px;
    }

    .gangweijibie .g {
        width: 68px;
        text-align: right;
        padding-right: 10px;
    }

    .gangweijibie .j {
        width: 55px;
        text-align: right;
        padding-right: 10px;
    }

</style>